import { QuotationService } from 'app/services/quotation.service';
import { ThunkResult } from 'app/store/helpers';
import { QuotationActions } from 'app/store/data/quotation';

export const clearCepikMergeResult = (
  quotationId: string,
  options?: { withoutFirstRegDate?: boolean }
): ThunkResult => (dispatch) => {
  if (!options?.withoutFirstRegDate) {
    sessionStorage.removeItem('diffFirstRegDate');
    dispatchEvent(new Event('storage'));
  }

  QuotationService.setCepikMergeResult(quotationId, null);
  dispatch(QuotationActions.setQuotationQuestion(`cepikMergeResult`, null));
};
